import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AccountService } from '../../../../api/services/account.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../../services/auth.service';
import { UserDetailsModel } from '../../../../api/models/user-details-model';
import { ToastService } from '../../../../services/toast.service';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  standalone: false,
})
export class CreateUserComponent {
  @Output() userCreated = new EventEmitter<UserDetailsModel>();

  newUserForm = new FormGroup({
    firstName: new FormControl<string>('', Validators.required),
    lastName: new FormControl<string>('', Validators.required),
    email: new FormControl<string>('', [Validators.required, Validators.email]),
    mobile: new FormControl<string | undefined>(''),
  });

  /**
   * Whether the form is currently being submitted
   */
  submitting = false;

  constructor(
    public dialogRef: MatDialogRef<CreateUserComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      accountGuid: string;
    },
    private accountService: AccountService,
    private authService: AuthService,
    private toastService: ToastService,
  ) {}

  /**
   * Creates a new user for the account
   */
  createNewUser() {
    this.submitting = true;
    this.accountService
      .accountUsersPost(
        {
          accountGuid: this.data.accountGuid,
          body: {
            firstName: this.newUserForm.controls.firstName.value!,
            lastName: this.newUserForm.controls.lastName.value!,
            email: this.newUserForm.controls.email.value!,
            mobile: this.newUserForm.controls.mobile.value ?? undefined,
          },
        },
        this.authService.getAuthorisationHeaders(),
      )
      .subscribe({
        next: (createdAccount) => {
          this.userCreated.emit(createdAccount);
          this.toastService.success('User Added To Account');
          this.submitting = false;
          this.dialogRef.close();
        },
        error: () => {
          this.toastService.error('Could Not Add User');
          this.submitting = false;
        },
      });
  }
}
